import { Card } from 'react-bootstrap';
import styled from 'styled-components';
import { colors } from '../../../theme/theme';

export const CustomCard = styled(Card)`
    border: 0px;
    width: 100%;
    cursor: pointer;
    min-height: 72px;
    
    border-left: 10px solid ${colors.mainColors.blueberry};
    border-radius: 8.63px;
    align-items: flex-start;
    h6 { 
        font-size: 16px;
        font-weight: 700;
        color: #000;
    }

    margin-bottom: 15px;
    transition: 0.2s ease-out;

    &:hover { 
        transform: scale(1.01);
        transition: 0.2s ease-out;
    }

    .utilsButtons { 
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        justify-content: center;
        align-items: center;

        @media only screen and (max-width: 1000px) { 
        flex-direction: row;
        }
    }

`

export const CardBody = styled(Card.Body)`
    flex-direction: column;
    padding: 10px 17px 10px 15px;
    gap: 5px;
    width: 100%;

    svg {
        color: ${colors.greyscale.darker_grey};
    }

`

export const CardTitle = styled.div`
    width: 100%;
    justify-content: space-between;

    button { 
        background-color: transparent;
        border: 0px;
    }
    
`;

export const CardMain = styled.main`
    flex-direction: row;
    gap: 10px;
    justify-content: space-between;
    

    div { 
        display:flex;
        flex-direction: column;
    }
`;

export const CardButton = styled.div`
    margin-top: 10px;
    
    button { 
        background-color: transparent;
        border: 0px;
    }
`;

export const LimitCharacterDiv = styled.div`
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 220px;
    color: ${colors.greyscale.darker_grey}
`;